import type { ExampleJob } from "@/lib/example";

/** A card in a preview, as the places draw theirs. */
export const CARD = "rounded-2xl border border-line bg-card shadow-card";

/** A job as a row names it: the title, then the company and where. */
export default function JobLine({ job, after }: { job: ExampleJob; after?: string }) {
    return (
        <span className="flex min-w-0 flex-col gap-0.5">
            <span className="text-[15px] font-semibold leading-snug">{job.title}</span>
            <span className="text-[13px] text-fg-muted">
                <span className="font-semibold text-fg">{job.company}</span> · {job.where}
                {after && ` · ${after}`}
            </span>
        </span>
    );
}
